import { ProfileUpdateEmailMutation } from './profile/profile-update-email-mutation';
import { ProfileUpdatePhoneMutation } from './profile/profile-update-phone-mutation';
import { ProfileVerifyEmailMutation } from './profile/profile-verify-email-mutation';
import { ProfileVerifyPhoneMutation } from './profile/profile-verify-phone-mutation';
import { TwoFaChallengeMutation } from './two-fa/two-fa-challenge-mutation';
import { TwoFaValidateMutation } from './two-fa/two-fa-validate-mutation';
import { CreateFingerprintMutation } from './user/create-fingerprint-mutation';
import { LoginMutation } from './user/login-mutation';
import { FbeConfigQuery } from './user/fbe-config-query';
export var endpoints = {
    profileUpdateEmail: new ProfileUpdateEmailMutation(),
    profileUpdatePhone: new ProfileUpdatePhoneMutation(),
    profileVerifyEmail: new ProfileVerifyEmailMutation(),
    profileVerifyPhone: new ProfileVerifyPhoneMutation(),
    twoFaChallenge: new TwoFaChallengeMutation(),
    twoFaValidate: new TwoFaValidateMutation(),
    createFingerprint: new CreateFingerprintMutation(),
    login: new LoginMutation(),
    getFbeConfig: new FbeConfigQuery(),
};
